import { create } from 'zustand';

export type TrialContentSource =
  | 'trialProcessingScreen'
  | 'trialProjectEditor'
  | 'trialProjectPreview';

type TrialContentScreenStore = {
  trialContentSource: TrialContentSource | undefined;
  setTrialContentSource: (source: TrialContentSource | undefined) => void;
};

export const useTrialContentScreenStore = create<TrialContentScreenStore>((set) => ({
  trialContentSource: undefined,
  setTrialContentSource: (source) => set({ trialContentSource: source }),
}));
